import {
  TextInputField,
  SimpleModal,
  Box,
  Flex
} from '@sequencehq/core-components'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'
import { useState } from 'react'
import { useCreditNoteActions } from 'CreditNotes/hooks/useCreditNoteActions'

type Props = {
  creditNoteId: string
  isOpen: boolean
  onClose: () => void
}

export const SendTestCreditNoteDialog = ({
  creditNoteId,
  isOpen,
  onClose
}: Props) => {
  const [testEmail, setTestEmail] = useState('')
  const { sendTestCreditNote } = useCreditNoteActions(creditNoteId)

  const handleSubmit = async () => {
    try {
      await sendTestCreditNote.mutateAsync(testEmail)
    } catch {
      // The mutation's onError toast covers messaging; keep the dialog open
      // so the send can be retried in place.
      return false
    }

    return true
  }

  return (
    <SimpleModal
      data-testid="modal.sendTestCreditNote"
      variant="dialog"
      isOpen={isOpen}
      onClose={onClose}
      title="Send test credit note email"
      submitButtonText="Send test credit note"
      submittingButtonText="Sending..."
      onSubmit={handleSubmit}
      submitDisabled={testEmail.length === 0}
      disableSubmitOnEnter
    >
      <Flex flexDirection="column" gap="16px">
        <Box {...Primary13Regular} color={GreyGrey80}>
          Send a test email with this credit note attached.
        </Box>
        <TextInputField
          data-testid="testCreditNoteDialog.email"
          value={testEmail}
          validationErrors={undefined}
          onChange={event => setTestEmail(event.target.value)}
          placeholder="test@sequencehq.com"
        />
      </Flex>
    </SimpleModal>
  )
}
